<template>
  <div class="card white-box">
    <div class="title-con" v-if="cardData.model!=='lockDetail'">
      <p class="title">{{cardData.title}}</p>
      <p class="sign" v-if="cardData.model!=='real_time'">以下统计数据截止到昨天
        <!-- <span v-if="cardData.title=='我的销售情况'&&promotorType=='2'"><br>用户锁定单的销售分成暂时会进入合伙人喜马拉雅账号，请联系合伙人咨询相关信息。</span> -->
      </p>
    </div>
    <!-- <p class="">以下统计数据截止到昨天</p> -->
    <card-number :numberData="{model:cardData.model, data:cardData.data}" :promotorType = "promotorType"
                 v-if="cardData.model && cardData.model=='real_time'"></card-number>
    <el-tabs v-model="activeName" v-else>
      <el-tab-pane :label="tab.txt" :name="index.toString()" v-for="(tab,index) in tabList" :key="tab.key">
        <card-number v-if="cardData.type==='number'" :numberData="{data:cardData.data[tab.key]}"></card-number>
        <card-table v-else :tableData="propstable[tab.key] || {}"></card-table>
      </el-tab-pane>
    </el-tabs>
    <el-pagination v-if="cardData.type=='table'"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page.sync="cardData.data.curPage"
                   :page-sizes="[10, 20, 30, 40]"
                   :page-size="pageSize"
                   layout="total, sizes, prev, pager, next"
                   :total="cardData.data.total">
    </el-pagination>
  </div>
</template>

<script>
  import cardNumber from 'components/card/number'
  import cardTable from 'components/card/table'
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        activeName: '0',
        pageSize: 20,
        tabList: [
          {
            txt: '昨日',
            key: 'yesterday'
          },
          {
            txt: '7日',
            key: 'weekly'
          },
          {
            txt: '30日',
            key: 'monthly'
          },
          {
            txt: '汇总',
            key: 'summary'
          }
        ],
        tableData: [
          {
            goodsName: '鞋',
            goodsType: '100',
            user: '1',
            orderMoney: 'a',
            orderStatus: 'asdf',
            brokerage: 'uioiu'
          },
          {
            goodsName: '鞋',
            goodsType: '100',
            user: '1',
            orderMoney: 'a',
            orderStatus: 'asdf',
            brokerage: 'uioiu'
          },
          {
            goodsName: '鞋',
            goodsType: '100',
            user: '1',
            orderMoney: 'a',
            orderStatus: 'asdf',
            brokerage: 'uioiu'
          },
        ],
        propstable: {}
      }
    },
    components: {
      cardNumber, cardTable
    },
    props: ['cardData', 'pagSearch'],
    computed: {
      ...mapGetters([
        'promotorType'
      ])
    },
    mounted() {

    },
    methods: {
      getTableData(key) {
        const vis = this
        const data = vis.cardData.data
        if (vis.cardData.type == 'table' && data.list) {
          let tableKey = vis.cardData.key //['name', 'salesAmount', 'commission', 'paidOrderCount', 'paidUserCount', 'lockUserCount']

          const dataList = data.list
          let temp = {
            "totalPages": Math.ceil(data.total/data.pageSize),
            "curPage": data.curPage,
            "totalRecords": data.total,
            list: []
          }

          let changeTableKey = []
          dataList.forEach(item => {
            let tmp = {}
            changeTableKey = []
            tableKey.map((keyItem, index) => {
              if (keyItem == 'name') {
                tmp[keyItem] = item[keyItem]
                changeTableKey.push(keyItem)
              } else if (item[key]) {
                for(var iKey in item[key]){
                  tmp[iKey] = item[key][iKey]
                }
                changeTableKey.push(keyItem)
              }
            })
            temp.list.push(tmp)
          })
          temp['keyList'] = changeTableKey
          return temp
        }
      },
      handleSizeChange() {
        this.pageSize = arguments[0]
        this.$emit('pagSearch', {'pageSize': this.pageSize, curPage: this.cardData.data.curPage});
      },
      handleCurrentChange() {
        this.$emit('pagSearch', {pageSize: this.pageSize, curPage: arguments[0]});
      }
    },
    watch: {
      cardData: function () {
        let vis = this
        const cadata = this.cardData
        if (cadata.type == 'table' && cadata.data.list) {
          const dataKey = ['yesterday', 'weekly', 'monthly', 'summary']
          dataKey.forEach(key => {
            vis['propstable'][key] = vis.getTableData(key)
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card {
    width: 720px;
    .title-con {
      border-bottom: 1px solid #dfe6ec;
      min-height: 60px;
    }
    .title {
      height: 20px;
      padding-top: 17px;
      //line-height: 54px;
      font-size: 20px;
    }
    .sign {
      font-size: 13px;
      margin-top: 25px;
      padding-left: 20px;
      color: #999;
      margin-bottom: 6px;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?682f9dc9